import React, { useRef, useState } from "react";
import { Autoplay } from "swiper/modules";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import partner1 from "../../assets/images/partner-1.png";
import partner2 from "../../assets/images/partner-2.png";
import partner3 from "../../assets/images/partner-3.png";
import partner4 from "../../assets/images/partner-4.png";

import "swiper/css";

export default function Partners() {
  return (
    <div className="container my-5">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 30,
          }
        }}
        // centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={partner1} alt="Partner 1" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner2} alt="Partner 2" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner3} alt="Partner 3" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner4} alt="Partner 4" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner1} alt="Partner 1" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner2} alt="Partner 2" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner3} alt="Partner 3" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={partner4} alt="Partner 4" className="shadow-2 border-1 border-gray-300" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
